import React from "react";
import { Eligibility } from "../../../containers";

const Eligibilitys = (props) => {
  return <Eligibility {...props} />;
};

export default Eligibilitys;
